import { render, staticRenderFns } from "./RechargePrepaidTest.vue?vue&type=template&id=2609d96c&scoped=true&"
import script from "./RechargePrepaidTest.vue?vue&type=script&lang=js&"
export * from "./RechargePrepaidTest.vue?vue&type=script&lang=js&"
import style0 from "./RechargePrepaidTest.vue?vue&type=style&index=0&id=2609d96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2609d96c",
  null
  
)

export default component.exports